import { useTexts } from '../../useTexts'

import { createCustomFieldColumn } from './createCustomFieldColumn'
import { createExecutedCustomFieldColumn } from './createExecutedCustomFieldColumn'
import { createExecutedLoadColumn } from './createExecutedLoadColumn'
import { createLoadColumn } from './createLoadColumn'
import { getValue } from './getValue'

export function createGenericColumn(
  colDef: { field: string; hide: boolean; width: number },
  texts: ReturnType<typeof useTexts>,
  enableDynamicLoads: boolean,
  enableDynamicCustomFields: boolean,
  loadsInOrders: string[],
  executedLoadsInOrders: string[],
  customFieldInOrders: string[],
  executedCustomFieldInOrders: string[],
) {
  // If is a load and the field exists in the orders
  if (colDef.field.startsWith('formattedData.loads.') && loadsInOrders.includes(colDef.field))
    return createLoadColumn(colDef, texts, enableDynamicLoads)

  if (
    colDef.field.startsWith('formattedData.executedLoads.') &&
    executedLoadsInOrders.includes(colDef.field)
  )
    return createExecutedLoadColumn(colDef, texts)

  // If is a custom field and the field exists in the orders
  if (
    colDef.field.startsWith('formattedData.customFields.') &&
    customFieldInOrders.includes(colDef.field)
  )
    return createCustomFieldColumn(colDef, texts, enableDynamicCustomFields)

  if (
    colDef.field.startsWith('formattedData.executedCustomFields.') &&
    executedCustomFieldInOrders.includes(colDef.field)
  )
    return createExecutedCustomFieldColumn(colDef, texts)

  // Generic column for other fields (not loads or custom fields)
  if (
    !colDef.field.startsWith('formattedData.loads.') &&
    !colDef.field.startsWith('formattedData.executedLoads.') &&
    !colDef.field.startsWith('formattedData.customFields.') &&
    !colDef.field.startsWith('formattedData.executedCustomFields.')
  )
    return {
      type: 'string',
      hide: colDef.hide,
      filterable: false,
      field: colDef.field,
      valueGetter: getValue,
      headerName: colDef.field,
      width: colDef.width || 200,
    }
}
